require('normalize.css');

export default {
  colors: {
    primary: 'white',
    secondary: '#ff2d20',
    transparent: '#ffb9b5',
    tertiary: '#333333',
    quaternary: '#ff2d20',
    light: '#d8d8d8',
    faded: '#999999',
    backgroundColor: '#FFFFFF'
  },
  fonts: {
    primary: 'Montserrat',
    secondary: 'Helvetica',
    tertiary: 'JetBrains Mono'
  },
  fontSizes: {
    xxl: '6rem',
    xl: '4rem',
    lg: '3rem',
    md: '2rem',
    sm: '1.5rem',
    xs: '1rem',
  }
};
